<script lang="ts">
  import type { OrganizationOnboardingSummaryMetric } from "../../../../../../../../../../../../../../../../api/kehrblatt/organization-onboarding"

  let { metrics = [] }: { metrics?: OrganizationOnboardingSummaryMetric[] } = $props()
</script>

{#if metrics.length}
  <div class="metric-strip" aria-label="Einrichtungskennzahlen">
    {#each metrics as metric}
      <div class="metric metric--{metric.tone ?? 'neutral'}">
        <strong>{metric.value}</strong>
        <span>{metric.label}</span>
      </div>
    {/each}
  </div>
{/if}

<style lang="less">
  .metric-strip {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(8rem, 1fr));
    gap: 0.5rem;
    width: 100%;
  }

  .metric {
    border: 1px solid color-mix(in srgb, var(--text-100) 18%, transparent);
    padding: 0.55rem 0.65rem;
    min-width: 0;
  }

  strong,
  span {
    display: block;
  }

  strong {
    color: var(--text-100);
    font-size: 1.15rem;
    line-height: 1.1;
  }

  span {
    color: color-mix(in srgb, var(--text-100) 68%, transparent);
    font-size: 0.78rem;
    line-height: 1.25;
    margin-top: 0.18rem;
  }

  .metric--success {
    border-color: color-mix(in srgb, var(--confirm-100) 52%, transparent);
  }

  .metric--warning {
    border-color: color-mix(in srgb, var(--yellow-100) 58%, transparent);
  }
</style>
